import { render, staticRenderFns } from "./InputFormatoMoneda.vue?vue&type=template&id=340ca77d&"
import script from "./InputFormatoMoneda.vue?vue&type=script&lang=js&"
export * from "./InputFormatoMoneda.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports